window.validateAndRedirect = function (value, totalPages) {
  console.log(
    "validateAndRedirect called with value:",
    value,
    "and totalPages:",
    totalPages
  );

  // Check if the input is empty
  if (!value.trim()) {
    console.log("Input is empty");
    alert("Enter a page number");
    return;
  }

  // Parse the input value
  var pageNumber = parseInt(value);

  // Check if the input is a valid page number
  if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > totalPages) {
    console.log("Input is not a valid page number:", pageNumber);
    alert("Invalid page number");
    return;
  }

  // Extract the base URL
  var baseUrl = window.location.href.replace(/\/page\/\d+\/?$/, "");
  console.log("Base URL:", baseUrl);

  // Construct the URL for the selected page
  var url = baseUrl + "/page/" + pageNumber;
  console.log("Redirecting to URL:", url);

  // Redirect to the selected page
  window.location.href = url;
};



const elWithClassExists = document.querySelectorAll(".pagination").length > 0;

if (elWithClassExists) {
  var elemParent = document.getElementById(
    "n0-last-column-in-index"
  ).parentNode;

  if (window.innerWidth > 991) {
    const cards = getPreviousSiblings(elemParent, filter).length;
    var interations = 0;

    switch (cards) {
      case 0:
      case 3:
      case 6:
        interations = 2;
        break;
      case 1:
      case 4:
      case 7:
        interations = 1;
        break;
      default:
    }

    for (let i = 0; i < interations; i++) {
      const fragment = document.createDocumentFragment();
      const theDiv = fragment.appendChild(document.createElement("div"));
      theDiv.className = "col";
      const theDivsDiv = theDiv.appendChild(document.createElement("div"));
      theDivsDiv.className = "card h-100 bg-dark bg-gradient n0-white-link";
      elemParent.parentNode.appendChild(fragment);
    }
  }

  function getPreviousSiblings(elem, filter) {
    var sibs = [];
    while ((elem = elem.previousSibling)) {
      if (elem.nodeType === 3) continue; // text node
      if (!filter || filter(elem)) sibs.push(elem);
    }
    return sibs;
  }

  function filter(elem) {
    switch (elem.nodeName.toUpperCase()) {
      case "DIV":
        return true;
      default:
        return false;
    }
  }
}

// Handlebars.registerHelper("times", function (n, block) {
//   var accum = "";
//   for (var i = 0; i < n; ++i) accum += block.fn(i);
//   return accum;
// });

// $(document).ready(function () {
//   $("#option1").click(function () {
//     window.location.href = "https://www.google.com/";
//   });
//   $("#option2").click(function () {
//     window.location.href = "https://www.bing.com/";
//   });
//   $("#option3").click(function () {
//     window.location.href = "https://www.yahoo.com/";
//   });
// });

// // Pagination drop down: #n0-pagination-dropdown
// var dropdownElementList = [].slice.call(
//   document.querySelectorAll(".dropdown-toggle")
// );
// var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
//   return new bootstrap.Dropdown(dropdownToggleEl);
// });

//move n0-hide-featured-title to after video
const isVideoCard = document.querySelectorAll(".kg-video-card").length > 0;

if (isVideoCard) {
  var s = document.getElementById("n0-hide-featured-title");
  var t = document.getElementsByClassName("kg-video-card")[0];
  var num = document.getElementById("default-post-content").childNodes.length;
  const is2column = document.querySelectorAll("#n0-col2").length > 0;

  // var parentToNode = document.createElement("div");
  // parentToNode.className = "col-md-6 col-sm-12";
  // parentToNode.id = "n0-col2";

  // Remove title hr from above video
  const element = document.getElementById("n0-video-title-hr");
  element.remove();

  if (is2column) {
    var v = document.getElementById("n0-col2");
    var w = document.getElementById("default-post-content");

    var node2 = document.createElement("section");
    node2.className = "post-content";

    // move video oput of content to top
    w.parentElement.insertBefore(w.children[0], w.parentElement.firstChild);

    // move title to second column
    var s = document.getElementById("n0-hide-featured-title");
    v.insertBefore(s, v.firstChild);

    // content
    v.insertBefore(w, v.children[1]);

    // title hr
    if (num > 3) {
      const node = document.createElement("hr");
      v.insertBefore(node, v.children[1]);
    }
  } else {
    var v = document.getElementsByClassName("kg-card kg-video-card")[0];
    var parentV = v.parentElement.parentElement;
    parentV.insertBefore(v, parentV.children[0]);

    // title hr
    if (num > 3) {
      const node = document.createElement("hr");
      parentV.insertBefore(node, parentV.children[2]);
    }
  }
}

// var y = document.getElementsByClassName("kg-video-container")[0];
// y.firstChild.innerWidth = "100%";

// Enable dismissal of an alert via JavaScript:
// var alertList = document.querySelectorAll(".alert");
// alertList.forEach(function (alert) {
//   new bootstrap.Alert(alert);
// });

// const messageAlert = document.getElementById("n0n-message-alert-id");

// ".n0n-message-alert-id-offscreen { border: 0; clip: rect(0 0 0 0); height: 1px; margin: -50px; overflow: hidden; padding: 0; position: absolute; width: 1px; }";

// if (sessionStorage.getItem("message-alert-closed")) {
// const rule = ".n0n-message-alert-id-offscreen { visibility: hidden; border: 0; height: 0 !important; margin: 0; padding: 0 !important;}";
// document.styleSheets[0].insertRule(rule);
// messageAlert.close();
// messageAlert.remove();
// }

// document.addEventListener("DOMContentLoaded", function () {
//     messageAlert.addEventListener("closed.bs.alert", function () {
//       sessionStorage.setItem("message-alert-closed", "true");
//       messageAlert.close();
//       messageAlert.remove();
//     });
// });

// window.onload = function () {
//   const messageAlert = document.getElementById("n0n-message-alert-id");

//   if (sessionStorage.getItem("message-alert-closed")) {
//     // messageAlert.remove();
//     messageAlert.className = "n0n-message-alert-id-offscreen";
//   } else {
//     console.log("Alert open. Adding listener");
//     messageAlert.classList.remove("n0n-message-alert-id-offscreen");
//     messageAlert.addEventListener("closed.bs.alert", function () {
//       messageAlert.className = "n0n-message-alert-id-offscreen";
//       sessionStorage.setItem("message-alert-closed", "true");
//     });
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {

//   var messageAlert = document.getElementById("n0n-message-alert-id");
//   console.log(messageAlert);

//   if (!sessionStorage.getItem("message-alert-closed")) {
//     console.log("Adding event listener to open alert..");
//     messageAlert.addEventListener("closed.bs.alert", function () {
//       sessionStorage.setItem("message-alert-closed", "true");
//     });
//   }

//   if (sessionStorage.getItem("message-alert-closed")) {
//     console.log("Closing alert.");
//     messageAlert.close();
//   }
